import * as Actions from '../actions/organisation.actions';
import * as Constants from '../actions/organisation.constants';
import * as AuthConstants from '../actions/auth.constants';
import { OrganisationState } from '../types/organisation-state';

const defaultState: Partial<OrganisationState> = {
  loading: false,
  organisations: [],
  preselectedOrg: ''
};

export function reducer(state: Partial<OrganisationState> = defaultState, action: Actions.All)
  : Partial<OrganisationState> {

  switch (action.type) {
    case Constants.GET_ORGANISATIONS:
      return { ...state, loading: true, message: undefined, organisations: [] };
    case Constants.GET_ORGANISATIONS_SUCCESS:
      return { ...state, loading: false, message: undefined };
    case Constants.GET_ORGANISATIONS_FAILED:
      const { message } = action as Actions.GetOrganisationsFailedAction;
      return { ...state, loading: false, message, organisations: [] };
    case Constants.UPDATE_ORGANISATIONS:
      const { organisations } = action as Actions.UpdateOrganisationsAction;
      return { ...state, organisations };
    case Constants.LOGIN_TO_ORGANISATION:
      return { ...state, loading: true, message: undefined };
    case Constants.LOGIN_TO_ORGANISATION_FAILED:
      const { message: m } = action as Actions.LoginToOrganisationFailedAction;
      return { ...state, loading: false, message: m };
    case Constants.PRESELECT_ORGANISATION: {
      const { tenantId } = action as Actions.PreselectOrganisationAction;
      return { ...state, preselectedOrg: tenantId };
    }
    case AuthConstants.INVALIDATE_SESSION:
      return { ...defaultState };
    default:
      return state;
  }
}